import React, { useState } from "react";
/* import { serviceDropdown } from "./NavItems"; */
import { Link } from "react-router-dom";
import "./Dropdown.css";

function Dropdown(props) {
  const [dropdown, setDropdown] = useState(false);
  let {submenus} = props;
  return (
    <>
      <ul
        className={dropdown ? "services-submenu clicked" : "services-submenu"}
        onClick={() => setDropdown(!dropdown)}
      >
        {submenus.map((item) => {

          if(item.path == '/marketing'){
            return(
              <li key={item.id}>
              <a
                href='https://mkt.softwone.com'
                target="_blank"
                className={item.cName}
                onClick={() => setDropdown(false)}
              >
                {item.title}
              </a>
            </li>
            )
          }
          else{
          return (
            <li key={item.id}>
              <Link
                to={item.path}
                className={item.cName}
                onClick={() => setDropdown(false)}
              >
                {item.title}
              </Link>
            </li>
          );
        }})}
      </ul>
    </>
  );
}

export default Dropdown;
